import lozad from "lozad";
window.lozad = lozad;

/* Inizializza LOZAD.
   Le [data-differita] restano fuori: le carica il blocco piu' sotto dopo l'evento
   load. Lasciarle qui le farebbe partire all'avvio, e per le <picture> con una
   <source> mobile sarebbe peggio: lozad imposta solo src (la desktop) e ignora
   la <source>, quindi su telefono la slide 2 dell'hero scaricava ENTRAMBE le
   versioni (93 KB + 22 KB), perche' toccando il bordo destro dello schermo
   l'IntersectionObserver la considera gia' intersecante. */
const el = document.querySelectorAll("img:not([data-differita])");
const observer = lozad(el);
const observer_background_image = lozad('.lozad');
// const observer = lozad(el, {
//     loaded: function(el) {
//         console.log('loading element');
//     }
// });
// const observer_background_image = lozad('.lozad', {
//     loaded: function(el) {
//         console.log('loading element');
//     }
// });

observer.observe();
observer_background_image.observe();

/* Foto sotto la piega (img[data-anticipo] con data-src/data-srcset): partono
   poco prima di entrare nello schermo e MAI prima del primo disegno.
   loading="lazy" non basta: Chrome le carica entro ~1250 px dalla piega (2500
   con una connessione piu' lenta) e Lighthouse mobile le conta fra i byte che
   precedono l'LCP, dove si dividono la banda con il CSS (LCP fra 3,0 e 5,4 s a
   seconda di quale arriva prima del primo disegno). Margine di 400 px: abbastanza
   vicino perche' non si veda il caricamento, abbastanza lontano perche' non parta
   all'avvio (la prima card di "Scopri anche" sta a ~600 px dal fondo di 412x823). */
const observer_anticipo = lozad('img[data-anticipo]', { rootMargin: '400px 0px' });
observer_anticipo.observe();

/* Immagini che servono "presto ma non subito" e che non stanno in nessun punto
   dello schermo che si possa osservare: le tessere del menu mobile (fuori
   schermo a sinistra), le slide successive dell'hero (fuori a destra), il logo
   dello screensaver. [data-differita] + data-src/data-srcset (anche su <source>):
   partono DOPO l'evento load, a browser libero, quindi mai prima del primo
   disegno, e sono pronte quando l'utente le apre o l'autoplay le mostra. */
const carica_differite = () => {
    document.querySelectorAll('[data-differita]').forEach((nodo) => {
        if (nodo.dataset.srcset) nodo.srcset = nodo.dataset.srcset;
        if (nodo.dataset.src) nodo.src = nodo.dataset.src;
        nodo.removeAttribute('data-differita');
    });
};
const avvia_differite = () => (window.requestIdleCallback || ((f) => setTimeout(f, 200)))(carica_differite, { timeout: 2000 });
if (document.readyState === 'complete') {
    avvia_differite();
} else {
    window.addEventListener('load', avvia_differite, { once: true });
}

$(document).ready(function () {
    const base64image = $('.base64image');
    $.each(base64image, function (i, v) {
        $(v).attr('src','data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZAAAAEsCAYAAADtt+XCAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAABD1JREFUeJzt1UENwDAQwLCusMqf1w3D8pkq2QjyyzMzZwHAR/vvAADuZCAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkBiIAAkBgJAYiAAJAYCQGIgACQGAkDyAm0PBY/ZJyofAAAAAElFTkSuQmCC');
    });
});